<div class="min-h-screen">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-overlay"></div>

    <div class="hero-container">
      <div class="hero-content">
        <h1 class="hero-title">DUNA</h1>
        <h2 class="hero-subtitle">Din platform til uddannelse og overblik</h2>
        <p class="hero-description">
          For brandfolk i hele landet – kurser, øvelser, FUI og GUI samlet ét
          sted.
        </p>

        <div class="hero-buttons">
          <a routerLink="/login" class="btn btn-primary">
            <i class="material-icons">login</i>
            Log ind
          </a>
        </div>
      </div>
    </div>

    <!-- Scroll indicator -->
    <div class="scroll-indicator">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </section>

  <!-- Feature Cards Section -->
  <section class="features-section">
    <div class="container">
      <div class="text-center section-header">
        <h2 class="section-title">DUNA's funktioner</h2>
        <p class="section-description">
          Alt du behøver for at administrere uddannelser, kurser og øvelser
          samlet på én moderne platform
        </p>
      </div>

      <div class="features-grid">
        @for (feature of features; track feature; let i = $index) {
        <div class="feature-card">
          <div class="feature-icon-container">
            <i class="material-icons">{{ feature.icon }}</i>
          </div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </div>
        }
      </div>
    </div>
  </section>

  <!-- Before/After Section -->
  <section class="comparison-section">
    <div class="container">
      <div class="text-center section-header">
        <h2 class="section-title">Fra kaos til kontrol</h2>
        <p class="section-description">
          DUNA erstatter rodede Excel-ark og analoge systemer med en samlet
          digital løsning
        </p>
      </div>

      <div class="comparison-container">
        <!-- Before - Old system -->
        <div class="comparison-before">
          <h3 class="comparison-title">Før DUNA</h3>
          <div class="before-items">
            <div class="before-item">
              <i class="material-icons">folder</i>
              <span>Papirbaserede systemer</span>
            </div>
            <div class="before-item">
              <i class="material-icons">description</i>
              <span>Excel-ark og regneark</span>
            </div>
            <div class="before-item">
              <i class="material-icons">notifications_off</i>
              <span>Manuelle påmindelser</span>
            </div>
          </div>
        </div>

        <!-- After - DUNA system -->
        <div class="comparison-after">
          <h3 class="comparison-title">Med DUNA</h3>
          <div class="duna-interface">
            <div class="interface-header">
              <h4>Mine kurser</h4>
              <div class="status-indicator"></div>
            </div>
            <div class="interface-content">
              <div class="course-item">
                <div class="course-name">Grunduddannelse</div>
                <div class="course-date">15. marts 2024</div>
              </div>
              <div class="course-item">
                <div class="course-name">Øvelse - Redning</div>
                <div class="course-date">22. marts 2024</div>
              </div>
            </div>
            <div class="interface-footer">
              <div class="footer-message">Alt samlet på én platform</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Fire Stations Section -->
  <section class="stations-section">
    <div class="container">
      <div class="text-center section-header">
        <h2 class="section-title">Disse brandstationer valgte DUNA først</h2>
        <p class="section-description">
          Førende brandstationer i Danmark stolede på DUNA fra starten
        </p>
      </div>

      <div class="stations-grid">
        @for (station of stations; track station) {
        <div class="station-card">
          <div class="station-logo">
            <span class="station-text">{{ station.name }}</span>
          </div>
          <p class="station-location">{{ station.location }}</p>
          <div class="first-mover-badge">
            <i class="material-icons">star</i>
            <span>Første bruger</span>
          </div>
        </div>
        }
      </div>
    </div>
  </section>

  <!-- Denmark Map Section -->
  <app-duna-map></app-duna-map>
</div>
